import { render, staticRenderFns } from "./DocumentSynthesisModal.vue?vue&type=template&id=33eecc73"
import script from "./DocumentSynthesisModal.vue?vue&type=script&lang=ts"
export * from "./DocumentSynthesisModal.vue?vue&type=script&lang=ts"
import style0 from "./DocumentSynthesisModal.vue?vue&type=style&index=0&id=33eecc73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports